// extracted by mini-css-extract-plugin
export default {"spinner":"m8FDMDQziP"};